import React, { useEffect, useState } from 'react';
import { TableSkeleton } from '../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import _debounce from 'lodash/debounce';
import { useForm } from 'react-hook-form';
import DataTable from 'react-data-table-component';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  useGetLeaveBalanceQuery,
  useAddLeaveBalanceMutation,
  useEditLeaveBalanceMutation,
  useDeleteLeaveBalanceMutation
} from '../../redux/apis/LeaveBalance';
import { useGetEmployeeQuery, useGetEmployeeDropDownQuery } from '../../redux/apis/employee';
import { useGetLeaveTypeQuery } from '../../redux/apis/LeaveType';

import EmptyData from '../../components/UI/EmptyData';
import PageHeader from '../../components/common/PageHeader';
import DeleteModel from '../../components/common/DeleteModel';
import { LeaveRequestData } from '../../components/Data/AppData';

import {
  LB_HEADER,
  LB_LEAVE_BALANCE_TABLE_COLS,
  LB_LEAVE_BALANCE_TABLE_COL_SORT,
  LB_EMPLOYEE_LEAVE_REQUEST
} from '../../utils/constant/labels';
import { GLOBAL } from '../../utils/constant/global';
import { fullName } from '../../utils/handler';
import { notification } from '../../utils/notification';
import { paginationRow, skipRow } from '../../utils/handler';
import { leaveBalanceSchema } from '../../utils/schemas/auth';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import { INPUT_LABEL, PLACEHOLDER } from '../../utils/constant/placeHolders';
import './LeaveBalance.scss';

const initialState = {
  isModal: false,
  isEditModalData: {},
  search: '',
  modalHeader: { title: '', isEdit: false },
  isEditModal: false,
  isDeleteModal: false,
  isDelete: { id: '', status: '' },
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  sortField: 'name',
  sortDirection: false,
  loading: false,
  selectedUserId: '',
  empData: [],
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50
};

const { LB_TBL_COL_EMPLOYEE_NAME, LB_TBL_COL_ACTION } = LB_LEAVE_BALANCE_TABLE_COLS;
const { LB_AVAILABLE, LB_BOOKED } = LB_EMPLOYEE_LEAVE_REQUEST;
const { SR_EMPLOYEE_NAME } = LB_LEAVE_BALANCE_TABLE_COL_SORT;
const {
  LB_ADD_LEAVE,
  LB_APPROVE,
  LB_SUCCESS_MSG,
  LB_REJECT,
  LB_LEAVE_BALANCE,
  LB_EDIT_LEAVE,
  LB_EXISTING_BALANCE,
  LB_NEW_BALANCE
} = LB_HEADER;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { LEAVE_BALANCE_CONTENT, DELETE_LEAVE_BALANCE, DESC, ASC } = GLOBAL;
const { PH_SEARCH_INPUT, PH_NEW_BALANCE, PH_EXISTING_BALANCE } = PLACEHOLDER;
const { BTN_SAVE, BTN_ACCEPT, BTN_REJECT: REJECT_BTN, BTN_ADD_LEAVE } = BT_BUTTON_LABELS;
const { LB_USER } = INPUT_LABEL;

function LeaveBalance() {
  const [state, setState] = useState(initialState);
  // const [isNameSelected, setIsNameSelected] = useState(false);
  // const [selectedUserId, setSelectedUserId] = useState('');

  const leaveBalanceTableStyles = {
    table: {
      style: {
        backgroundColor: 'transparent'
      }
    },
    headRow: {
      style: {
        backgroundColor: '#f8fafc',
        borderBottom: '1px solid #e6edf5',
        minHeight: '44px'
      }
    },
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: '12px',
        color: '#334155',
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        whiteSpace: 'normal',
        overflow: 'visible',
        paddingLeft: '14px',
        paddingRight: '14px'
      }
    },
    rows: {
      style: {
        minHeight: '64px',
        borderBottom: '1px solid #eef2f7',
        backgroundColor: '#ffffff'
      },
      highlightOnHoverStyle: {
        backgroundColor: '#f5f8ff',
        borderBottomColor: '#e6edf5',
        outline: 'none'
      }
    },
    cells: {
      style: {
        color: '#6b7280',
        fontWeight: 600,
        fontSize: '13px',
        paddingLeft: '14px',
        paddingRight: '14px',
        whiteSpace: 'normal',
        overflow: 'visible',
        alignItems: 'center'
      }
    },
    pagination: {
      style: {
        borderTop: '1px solid #eef2f6',
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    }
  };

  // const { control } = useForm();

  const { data: leaveTypeData, refetch: getLeaveType } = useGetLeaveTypeQuery({ search: '' });
  console.log('leaveTypeData', leaveTypeData);

  const {
    // data: employeeData,
    refetch: refetchEmployee
  } = useGetEmployeeQuery({
    search: '',
    skip: skipRow(state.currentPage, state.rowsPerPage),
    limit: state.rowsPerPage
  });
  const { data: dropdownData, refetch: employeeDropDownQuery } = useGetEmployeeDropDownQuery({
    skip: skipRow(state.currentPageDropdown, state.rowsPerPageDropdown),
    limit: state.rowsPerPageDropdown,
    search: state.dropdownSearch
  });
  const {
    data: leaveBalanceData,
    isLoading,
    isFetching,
    refetch: refetchLeaveBalance
  } = useGetLeaveBalanceQuery({
    search: state.search,
    skip: skipRow(state.currentPage, state.rowsPerPage),
    limit: state.rowsPerPage,
    sort: state.sortField,
    sortType: state.sortDirection ? DESC : ASC
  });
  const [addLeaveBalance] = useAddLeaveBalanceMutation();
  const [EditLeaveBalance] = useEditLeaveBalanceMutation();
  const [deleteLeaveBalance] = useDeleteLeaveBalanceMutation();

  const handleChangeSort = (sortField) => {
    setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
  };

  const defaultValue = {
    userId: '',
    leaveTypeId: '',
    availableBalance: '',
    bookedBalance: ''
  };
  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
    clearErrors
  } = useForm({
    resolver: yupResolver(leaveBalanceSchema),
    values: state.isEditModalData?._id
      ? { ...state.isEditModalData, userId: state.isEditModalData._id }
      : defaultValue
    // defaultValues: state.isEditModalData?._id ? state.isEditModalData : defaultValue
  });

  const formatBalance = (value) =>
    value === null || value === undefined || value === '' ? 0 : value;

  let columnT = [];
  columnT = [
    {
      name: LB_TBL_COL_EMPLOYEE_NAME,
      sortField: SR_EMPLOYEE_NAME,
      width: '220px',
      minWidth: '220px',
      grow: 0,
      selector: () => {},
      sortable: true,
      cell: (row) => {
        return (
          <div>
            <span className="fw-bold ms-1">{fullName(row)}</span>
          </div>
        );
      }
    }
  ];

  leaveTypeData?.data.forEach((leaveType) => {
    columnT.push({
      name: leaveType.name.toUpperCase(),
      minWidth: '120px',
      grow: 1,
      cell: (row) => {
        const leaveTypeInfo = row.leaveType?.find((leave) => leave._id === leaveType._id);
        if (!leaveTypeInfo) {
          return <span className="leave-balance-cell__empty">-</span>;
        }

        return (
          <div className="leave-balance-cell">
            <span className="leave-balance-cell__booked">
              {formatBalance(leaveTypeInfo.bookedBalance)}
            </span>
            <span className="leave-balance-cell__sep">/</span>
            <span className="leave-balance-cell__available">
              {formatBalance(leaveTypeInfo.availableBalance)}
            </span>
          </div>
        );
      }
    });
  });

  useEffect(() => {
    for (let i = 0; i < leaveTypeData?.data?.length; i++) {
      const element = leaveTypeData?.data[i];
      columnT.push({
        name: element.name,
        selector: (row) => row?.availableBalance || '',
        sortable: false
      });
    }
  }, [leaveTypeData]);

  columnT.push({
    name: LB_TBL_COL_ACTION,
    width: '88px',
    minWidth: '88px',
    grow: 0,
    selector: () => {},
    sortable: false,
    cell: (row) => (
      <RowActionMenu
        actions={[
          {
            label: 'Edit',
            icon: 'icofont-edit',
            variant: 'success',
            onClick: () => {
              setState({
                ...state,
                isModal: true,
                isEditModalData: row,
                modalHeader: { title: LB_EDIT_LEAVE, isEdit: true }
              });
            }
          }
        ]}
      />
    )
  });

  // const handleAddLeaveBalance = async (data) => {
  //   try {
  //     setState({ ...state, loading: true });
  //     const res = await addLeaveBalance(data);
  //     if (res?.data?.success) {
  //       refetchLeaveBalance();
  //       notification(res?.data?.statusMessage, TOAST_SUCCESS);
  //       setState({ ...state, isModal: false, loading: false });
  //       reset();
  //     } else {
  //       setState({ ...state, isModal: false, loading: false });
  //       notification(res?.error?.data?.statusMessage, TOAST_ERROR);
  //       reset();
  //     }
  //   } catch (error) {
  //     notification(error.message, TOAST_ERROR);
  //   }
  // };
  const handleAddLeaveBalance = async (data) => {
    try {
      setState({ ...state, loading: true });
      const filteredLeaveTypeData = data.leaveTypeData.filter(
        (leaveType) => leaveType.newBalance !== 0
      );

      if (filteredLeaveTypeData.length > 0) {
        const res = await addLeaveBalance({ ...data, leaveTypeData: filteredLeaveTypeData });
        if (res?.data?.success) {
          refetchLeaveBalance();
          notification(res?.data?.statusMessage, TOAST_SUCCESS);
          setState({ ...state, isModal: false, loading: false });
          reset();
        } else {
          setState({ ...state, isModal: false, loading: false });
          notification(res?.error?.data?.statusMessage, TOAST_ERROR);
          reset();
        }
      } else {
        notification('All leave balances are 0. No data sent.', TOAST_INFO);
        setState({ ...state, isModal: false, loading: false });
        reset();
      }
    } catch (error) {
      notification('All leave balances are already at 0.No changes were made.', TOAST_ERROR);
      setState({ ...state, isModal: false, loading: false });
    }
  };

  const handleEditBalance = async (data) => {
    try {
      setState({ ...state, loading: true });

      // Filter out leaveTypeData objects with newBalance = 0
      const filteredLeaveTypeData = data.leaveTypeData.filter(
        (leaveType) => leaveType.newBalance !== 0
      );
      // const filteredLeaveTypeData = data.leaveTypeData || [];

      if (filteredLeaveTypeData.length > 0) {
        const res = await EditLeaveBalance({
          data: { ...data, leaveTypeData: filteredLeaveTypeData },
          id: state.isEditModalData._id
        });
        if (res?.data?.success) {
          refetchLeaveBalance();
          reset();
          notification(res?.data?.statusMessage, TOAST_SUCCESS);
          setState({ ...state, isModal: false, loading: false });
        } else {
          reset();
          setState({ ...state, isModal: false, loading: false });
          notification(res?.error?.data?.statusMessage, TOAST_ERROR);
        }
      } else {
        notification('All leave balances are 0. No changes were made.', TOAST_INFO);
        setState({ ...state, isModal: false, loading: false });
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  // const handleEditBalance = async (data) => {
  //   try {
  //     setState({ ...state, loading: true });
  //     const res = await EditLeaveBalance({ data: data, id: state.isEditModalData._id });
  //     if (res?.data?.success) {
  //       refetchLeaveBalance();
  //       reset();
  //       notification(res?.data?.statusMessage, TOAST_SUCCESS);
  //       setState({ ...state, isModal: false, loading: false });
  //     } else {
  //       reset();
  //       setState({ ...state, isModal: false, loading: false });
  //       notification(res?.error?.data?.statusMessage, TOAST_ERROR);
  //     }
  //   } catch (error) {
  //     notification(error.message, TOAST_ERROR);
  //   }
  // };

  const onSubmit = (data) => {
    const addData = {
      userId: state.selectedUserId,
      leaveTypeData: Object.keys(data.leaveTypeData).map((leaveId) => ({
        leaveTypeId: leaveId,
        existingBalance: 0,
        newBalance: data.leaveTypeData[leaveId].bookedBalance
          ? Number(data.leaveTypeData[leaveId].bookedBalance)
          : 0
      }))
    };

    if (state.isEditModalData?._id) {
      const editData = {
        userId: state.isEditModalData?._id,
        leaveTypeData: Object.keys(data.leaveTypeData).map((leaveId) => {
          const matchedLeave = data.leaveType.find((leave) => leave._id === leaveId);
          const existingBalance = matchedLeave ? matchedLeave.availableBalance : 0;
          return {
            leaveTypeId: leaveId,
            existingBalance: existingBalance,
            newBalance: data.leaveTypeData[leaveId].bookedBalance
              ? Number(data.leaveTypeData[leaveId].bookedBalance)
              : existingBalance
          };
        })
      };
      handleEditBalance(editData);
    } else {
      handleAddLeaveBalance(addData);
    }
  };

  useEffect(() => {
    getLeaveType();
    refetchEmployee();
  }, []);

  const handleDeleteLeaveBalance = async (id) => {
    try {
      const res = await deleteLeaveBalance(id);
      if (res?.data?.success) {
        refetchLeaveBalance();
        setState({ ...state, isDelete: { id: '', status: false } });
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  useEffect(() => {
    refetchLeaveBalance();
    setState({ ...state, isNext: leaveBalanceData?.isNext });
  }, [state.search, state.sortDirection]);

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 300);

  const handleMenuScrollToBottom = async () => {
    if (dropdownData.isNext || state.dropdownSearch) {
      setState({ ...state, dropdownSearch: '' });
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  // useEffect(() => {
  //   setState({ ...state, dropdownDataStore: dropdownData?.data || [] });
  // }, []);

  useEffect(() => {
    if (dropdownData && Array.isArray(dropdownData.data)) {
      setState((prevState) => ({
        ...prevState,
        dropdownDataStore: [...prevState.dropdownDataStore, ...dropdownData.data]
      }));
    }
  }, [dropdownData]);

  return (
    <div className="container-xxl">
      <PageHeader
        headerTitle={LB_LEAVE_BALANCE}
        renderRight={() => {
          return null;
        }}
      />
      <div className="row clearfix g-3">
        <div className="col-sm-12">
          <div className="leave-balance-surface">
            <div className="leave-balance-surface__toolbar">
              <div className="leave-balance-surface__toolbarRow">
                <div className="leave-balance-search">
                  <i className="icofont-search leave-balance-search__icon" />
                  <input
                    className="form-control leave-balance-search__input"
                    placeholder={PH_SEARCH_INPUT}
                    onChange={(e) => {
                      debouncedOnSearchData(e.target.value);
                    }}
                  />
                </div>
                <div className="leave-balance-surface__actions">
                  <div className="leave-balance-legend" aria-label="Balance key">
                    <span className="leave-balance-legend__item">
                      <i className="leave-balance-legend__dot leave-balance-legend__dot--booked" />
                      {LB_BOOKED}
                    </span>
                    <span className="leave-balance-legend__item">
                      <i className="leave-balance-legend__dot leave-balance-legend__dot--available" />
                      {LB_AVAILABLE}
                    </span>
                  </div>
                  <button
                    type="button"
                    className="app-table-toolbar__add-btn"
                    onClick={() => {
                      setState({
                        ...state,
                        isModal: true,
                        isEditModalData: {},
                        modalHeader: { title: LB_ADD_LEAVE, isEdit: false }
                      });
                    }}
                  >
                    <i className="icofont-plus-circle"></i>
                    {BTN_ADD_LEAVE}
                  </button>
                </div>
              </div>
            </div>

            <div className="leave-balance-table">
              <DataTable
                title={LeaveRequestData.title}
                columns={columnT}
                data={leaveBalanceData?.data || []}
                defaultSortField="title"
                pagination
                paginationServer
                onSort={handleChangeSort}
                sortField={state.sortField}
                sortDirection={state.sortDirection}
                paginationTotalRows={paginationRow(
                  leaveBalanceData?.isNext,
                  state.rowsPerPage,
                  state.currentPage,
                  leaveBalanceData?.data?.length
                )}
                paginationPerPage={state.rowsPerPage}
                paginationRowsPerPageOptions={[5, 10, 20, 30]}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rangeSeparatorText: 'of',
                  selectAllRowsItem: state.isNext,
                  selectAllRowsItemText: 'All',
                  paginationButtonsDisabled: state.isNext
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                selectableRows={false}
                noDataComponent={<EmptyData />}
                className="leave-balance-table__datatable"
                customStyles={leaveBalanceTableStyles}
                highlightOnHover={true}
                progressPending={isLoading || isFetching ? true : false}
                progressComponent={<TableSkeleton columns={6} />}
              />
            </div>
          </div>
        </div>
      </div>
      <DeleteModel
        isOpen={() => {
          setState({ ...state, isDelete: { id: '', status: false } });
        }}
        open={state?.isDelete?.status}
        title={DELETE_LEAVE_BALANCE}
        message={LEAVE_BALANCE_CONTENT}
        isDelete={() => {
          handleDeleteLeaveBalance(state?.isDelete.id);
        }}
      />
      <Modal
        centered
        className="lb-modal"
        dialogClassName="lb-modal__dialog"
        contentClassName="lb-modal__content"
        show={state?.isModal}
        onHide={() => {
          reset();
          setState({ ...state, isModal: false });
        }}
      >
        <Modal.Header className="lb-modal__header">
          <div className="lb-modal__header-content">
            <span className="lb-modal__header-icon" aria-hidden="true">
              <i className="icofont-calendar" />
            </span>
            <div className="lb-modal__header-copy">
              <Modal.Title className="fw-bold lb-modal__title">
                {state.modalHeader.title}
              </Modal.Title>
              <p className="lb-modal__subtitle">
                {state.modalHeader.isEdit
                  ? 'Update the leave balance for this employee'
                  : 'Set the leave balance for this employee'}
              </p>
            </div>
          </div>
          <button
            type="button"
            className="btn-close lb-modal__close"
            aria-label="Close"
            onClick={() => {
              reset();
              setState({ ...state, isModal: false });
            }}
          />
        </Modal.Header>
        <form className="lb-modal__form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className="lb-modal__body">
            <div className="lb-modal__section">
              <div className="lb-modal__field">
                <label className="lb-modal__label">{LB_USER}</label>
                <Select
                  className="lb-modal__select"
                  classNamePrefix="lb-modal-select"
                  menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 100000 }) }}
                  onInputChange={(text) => {
                    if (text && text.length > 2) {
                      const data = state.dropdownDataStore.filter(({ name }) =>
                        name.toLocaleLowerCase().startsWith(text.toLocaleLowerCase())
                      );
                      if (data.length === 0) {
                        setState({ ...state, dropdownSearch: text });
                      }
                    }
                  }}
                  options={state.dropdownDataStore?.map((val) => ({
                    value: val._id,
                    label: val.name
                  }))}
                  id="userId"
                  {...register('userId')}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  placeholder="Select option..."
                  defaultValue={
                    state.isEditModalData?.name
                      ? { value: state.isEditModalData._id, label: state.isEditModalData.name }
                      : null
                  }
                  isDisabled={state.isEditModalData?._id}
                  onChange={(selectedOption) => {
                    setValue('userId', selectedOption.value);
                    setState({ ...state, selectedUserId: selectedOption.value });
                    clearErrors('userId');
                    // setSelectedUserId(selectedOption.value);
                    // setIsNameSelected(!!selectedOption);
                  }}
                />
                <small className="text-danger lb-modal__error">
                  {errors.userId && errors.userId.message}
                </small>
              </div>
              {leaveTypeData?.data?.map((leaveType) => {
                const existingLeaveType = state?.isEditModalData?.leaveType?.find(
                  (lt) => lt._id === leaveType._id
                );
                const existingBalance = existingLeaveType ? existingLeaveType.availableBalance : 0;
                return (
                  <div key={leaveType._id} className="lb-modal__type">
                    <div className="lb-modal__type-title">{leaveType.name.toUpperCase()}</div>
                    {state.isEditModalData._id ? (
                      <div className="lb-modal__grid">
                        <div className="lb-modal__field">
                          <label
                            htmlFor={`availableBalance_${leaveType._id}`}
                            className="lb-modal__label"
                          >
                            {LB_EXISTING_BALANCE}
                          </label>
                          <input
                            type="number"
                            value={existingBalance}
                            {...register(`leaveTypeData[${leaveType._id}].availableBalance`)}
                            className="form-control lb-modal__input"
                            placeholder={PH_EXISTING_BALANCE}
                            disabled={state.isEditModalData.leaveType}
                            id={`availableBalance_${leaveType._id}`}
                          />
                        </div>
                        <div className="lb-modal__field">
                          <label
                            htmlFor={`bookedBalance_${leaveType._id}`}
                            className="lb-modal__label"
                          >
                            {LB_NEW_BALANCE}
                          </label>
                          <input
                            type="string"
                            {...register(`leaveTypeData[${leaveType._id}].bookedBalance`)}
                            className="form-control lb-modal__input"
                            placeholder={PH_NEW_BALANCE}
                            min={0}
                            id={`bookedBalance_${leaveType._id}`}
                          />
                        </div>
                      </div>
                    ) : (
                      <input
                        type="string"
                        {...register(`leaveTypeData[${leaveType._id}].bookedBalance`)}
                        className="form-control lb-modal__input"
                        placeholder={PH_NEW_BALANCE}
                        min={0}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </Modal.Body>
          <Modal.Footer className="lb-modal__footer">
            <button type="submit" disabled={state.loading} className="btn lb-modal__submit">
              {state.loading ? (
                <div className="spinner-border spinner-border-sm" role="status"></div>
              ) : (
                <>
                  <i className="icofont-check-circled" aria-hidden="true" />
                  {BTN_SAVE}
                </>
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        centered
        show={state?.isEditModal}
        onHide={() => {
          setState({ ...state, isEditModal: false });
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title  fw-bold" id="dremovetaskLabel">
            {LB_APPROVE}
          </h5>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-simple-smile text-success display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_SUCCESS_MSG}</p>
          <button className="btn btn-success">{BTN_ACCEPT}</button>
        </Modal.Body>
      </Modal>
      <Modal
        centered
        show={state?.isDeleteModal}
        onHide={() => {
          setState({ ...state, isDeleteModal: false });
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title  fw-bold" id="leaverejectLabel">
            {LB_REJECT}
          </h5>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-sad text-danger display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_REJECT}</p>
          <button
            className="btn btn-danger"
            onClick={() => {
              handleDeleteLeaveBalance();
            }}
          >
            {REJECT_BTN}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LeaveBalance;
